<template>
  <div class="rule_index_warp">
    <div class="content" v-html="info"></div>
  </div>  
</template>
<script>
export default {
  data(){
    return{
      info:''
    }
  },
  methods:{
    getRuleDetails(){
      this.http({
        method:'get',
        url:'order/admin/wallet/withdraw/describe/'
      }).then(rps=>{
        this.info = rps.data;
      })
    }
  },
  created(){
    this.getRuleDetails();
  }
}
</script>
<style lang="less" scoped>
  .content{
    img{
      max-width: 100% !important;
    }
  }
</style>